import styled from 'styled-components';
import { colors } from '../constants';

export const GlobalAppStyle = styled.div`
    height: 100%;
    background-color: ${colors.white};
    color: ${colors.greenDark};
    overflow-y: auto;
    overflow-x: hidden;
    font-family: 'Orgon';

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        margin: 0;
        // This line overrides surrounding PNL styles
        font-family: 'Orgon';

        strong {
            font-weight: 700;
        }
    }

    h2 {
        font-weight: 300;
        font-size: 34px;
        line-height: 50px;
    }

    p {
        font-weight: 300;
        margin: 0;
    }

    button {
        font-family: inherit;
    }
`;
